/**
 * User: Shad
 * Date: 8/13/13
 */

"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};

var Address = module.exports = bunsen.Address = SoaModel.extend();


var Addresses = require('bunsen/collections/identity/Addresses');
var Backbone = require('dibs-backbone');
var SoaModelLabelAndValueTransformer = require('bunsen/models/SoaModelLabelAndValueTransformer');
var endpoints = require('dibs-endpoints');
var countryCodes = require('bunsen/libraries/helpers/country-codes-static'); // TODO: use geography service instead
var User = require('bunsen/models/identity/User');
var compact = require('lodash.compact');
var _ = require('underscore');

var validFor = function (type) {
    return this.get('validation.' + type + '.valid') === 'Y';
};

/**
 * @mixes SoaModel
 * @class
 * @property idAttribute {string} - "id"
 * @property urlRoot - endpoints.address
 * @property url - Backbone.Model.prototype.url
 * @type {*}
 */
_.extend(Address.prototype, SoaModelLabelAndValueTransformer, {
    idAttribute: "id",
    displayLabels: {
        countryCode: 'Country',
        contact: 'Name',
        fullName: 'Name',
        zipCode: 'ZIP/Postal Code',
        phoneNumber: 'Telephone',
        line1: 'Address 1',
        line2: 'Address 2',
        state: 'State/Province/Region',
        usState: 'State/Province/Region',
        payEmail: 'Payee Email Address',
        activationCode: 'Hyperwallet Account Activation ID'
    },

    relations: SoaModel.createRelations([
        {
            key: 'validation',
            type: Backbone.One,
            relatedModel: SoaModel.extend({
                relations: SoaModel.createRelations([
                    'buyerShipping',
                    'buyerBilling'
                ])
            }),
            omitFromSave: true
        }
    ]),

    initialize: function () {
        this.url = function () {
            return endpoints.address(this.id);
        };
    },

    /**
     * Currently, you can only create new addresses on the addressBook endpoint, while
     * deletes and updates can only be done through the address endpoint. Sync override
     * handles picking the correct endpoint
     */
    sync: function (method, model, options) {
        var self = this;
        if (method === 'create') {
            return User.gotCurrentUser().then(function (currentUser) {
                options.url = endpoints.addressBook(currentUser.id);
                return SoaModel.prototype.sync.call(self, method, model, options);
            });
        }
        return SoaModel.prototype.sync.call(this, method, model, options);
    },
    defaults: {
    },
    displayTransforms: {
        country: function (val) {
            return countryCodes[val];
        },
        countryCode: function () {
            return this.get('country');
        }
    },
    schemas: {
        country: {
            type: 'Select',
            options: {
                placeholder: 'Select a Country...',
                possibleVals: countryCodes
            }
        }
    },
    isValidShippingAddress: _.partial(validFor, 'buyerShipping'),
    isValidBillingAddress: _.partial(validFor, 'buyerBilling'),
    isCountryUS: function () {
        return this.get('country') === 'US';
    },
    getDisplayLocation: function () {
        var parts = compact([this.get('city'), this.get('state')]);
        if (parts.length < 2) {
            parts.push(this.get('country'));
        }
        return compact(parts).join(', ');
    },
    setStateFromZip: function () {
        var addresses = new Addresses();
        return addresses.fetchByZip(
            this.get('zipCode'),
            this.get('country')
        ).then(function () {
            var location = addresses.first();
            if (!location) {
                return this;
            }
            this.set('state', location.get('state'));
            return this;
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Address.js
// module id = 32
// module chunks = 63